export const GATEWAY_URL = process.env.REACT_APP_PINATA_GATEWAY || 'https://ipfs.io/ipfs/'

export const getIpfsUrl = (uri) => {
    if (!uri) {
        return undefined;
    }
    if (uri.includes('ipfs')) {
        const hash = uri.split('/ipfs/').pop();
        return `${GATEWAY_URL}/${hash}`;
    }
    return uri;
}
